"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDropdown = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var DomUtil_1 = require("../../utils/DomUtil");
var DropdownButton_1 = require("./DropdownButton");
/** @private */
// eslint-disable-next-line max-len
var SelectDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(SelectDropdown, _super);
    function SelectDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultLabelId = DomUtil_1.generateId();
        _this.labelId = function () { return _this.props.labelId || _this.defaultLabelId; };
        _this.defaultListId = DomUtil_1.generateId();
        _this.listId = function () { return _this.props.list.props.id || _this.defaultListId; };
        _this.dropdownButtonRef = React.createRef();
        _this.renderList = function () {
            var list = _this.props.list;
            var listAriaLabelledby = list.props['aria-labelledby'];
            return React.cloneElement(list, tslib_1.__assign({ 'aria-labelledby': listAriaLabelledby === undefined ? _this.labelId() : listAriaLabelledby, id: _this.listId() }, _this.makeListProps()));
        };
        return _this;
    }
    /**
     * Repositions the popup, if it is currently shown. Might be useful if the popup contents weren't finished sizing at the time that the
     * popup was shown, e.g. if it contained an image which was still loading.
     */
    SelectDropdown.prototype.repositionPopup = function () {
        var _a;
        (_a = this.dropdownButtonRef.current) === null || _a === void 0 ? void 0 : _a.repositionPopup();
    };
    /**
     * Toggles the dropdown popup.
     * @param open optional parameter, ```true``` to open the dropdown or ```false``` to close it.
     */
    SelectDropdown.prototype.toggle = function (open) {
        var _a;
        (_a = this.dropdownButtonRef.current) === null || _a === void 0 ? void 0 : _a.toggle(open);
    };
    SelectDropdown.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, list = _b.list, onChange = _b.onChange, onSelectAll = _b.onSelectAll, value = _b.value, dropdownProps = tslib_1.__rest(_b, ["children", "list", "onChange", "onSelectAll", "value"]);
        return (React.createElement(DropdownButton_1.DropdownButton, tslib_1.__assign({ "aria-controls": this.listId(), closeOnPopupBlur: true, labelId: this.labelId() }, dropdownProps, { "aria-haspopup": 'listbox', focusOnClose: true, 
            // eslint-disable-next-line deprecation/deprecation
            popupContent: dropdownProps.popupContent || ((_a = dropdownProps.renderPopupContent) === null || _a === void 0 ? void 0 : _a.call(dropdownProps)) || this.renderList(), ref: this.dropdownButtonRef }), this.renderButtonContent()));
    };
    return SelectDropdown;
}(React.PureComponent));
exports.SelectDropdown = SelectDropdown;
//# sourceMappingURL=SelectDropdown.js.map